"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReturnsAllScanCenter = isReturnsAllScanCenter;
const constants_1 = require("./constants");
function isReturnsAllScanCenter(scanCenterCode) {
    return constants_1.RETURNS_ALL_SCAN_CENTER_CODES.includes(scanCenterCode);
}
//# sourceMappingURL=is-returns-all-scan-center.js.map